import { useState } from "react";
import Box from "@mui/material/Box/Box";
import Paper from "@mui/material/Paper/Paper";
import FullTextModal from "./FullTextModal"; // adjust the path as needed
import RowCell from "./RowCell";

export interface TableRow {
    fieldName: string;
    value: string | undefined;
    isExpandable?: boolean;
    isDataShowable?: boolean | undefined;
}

interface Props {
    title: string;
    rows: TableRow[];
    headerColor?: string;
}

export function GenericInformationTable({
    title,
    rows,
    headerColor
}: Readonly<Props>) {
    const [open, setOpen] = useState(false);
    const [dialogContent, setDialogContent] = useState("");

    const handleShowMore = (content: string) => {
        setDialogContent(content);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setDialogContent("");
    };

    return (
        <div className="generic-information-table-container">
            <Paper className="generic-information-table">
                <Box
                    className={`generic-information-table-title-box ${
                        headerColor || "green-box"
                    }`}
                >
                    <h3 className="text-white">{title}</h3>
                </Box>
                <div aria-label="basic-information">
                    {rows.reduce((acc: JSX.Element[], _, index) => {
                        if (index % 2 === 0) {
                            acc.push(
                                <div
                                    key={`row-${Math.floor(index / 2)}`}
                                    className="generic-information-table-row"
                                >
                                    <RowCell
                                        row={rows[index]}
                                        isFullView={rows.length === index + 1}
                                        handleShowMore={handleShowMore}
                                    />
                                    {rows[index + 1] && (
                                        <RowCell
                                            row={rows[index + 1]}
                                            isFullView={false}
                                            handleShowMore={handleShowMore}
                                        />
                                    )}
                                </div>
                            );
                        }
                        return acc;
                    }, [])}
                </div>
            </Paper>

            <FullTextModal
                open={open}
                content={dialogContent}
                onClose={handleClose}
            />
        </div>
    );
}

export default GenericInformationTable;
